/* eslint-disable no-underscore-dangle */
import '@skyscanner/backpack-web/bpk-stylesheets';
import '@skyscanner/backpack-web/bpk-stylesheets/font';
import { afterDomContentLoaded } from 'saddlebag-browser';
import logger from 'saddlebag-logger';
import { isLoggedIn } from 'saddlebag-user-management';

import './public-path';
import './bootstrap/error-handling';
import { loadExternalScripts } from './scriptLoader';
import { redirectFromQueryString } from './utils/urls';

const { fixReAuthBug } = window.__internal;

(async () => {
  try {
    await loadExternalScripts();
  } catch (missing) {
    logger.logError({
      message: `Failed to load dependencies ${missing}`,
      component: 'index',
    });
  }

  try {
    // If fixReAuthBug is false, we want to keep the old logic.
    if (!fixReAuthBug && (await isLoggedIn())) {
      redirectFromQueryString(window);
      return; // it doesn't need to do anything else.
    }

    afterDomContentLoaded(async () => {
      const { default: hydrate } = await import('./hydrate');
      hydrate();

      if (fixReAuthBug && (await isLoggedIn())) {
        // If fixReAuthBug is true, we want to have the new logic.
        redirectFromQueryString(window);
        return; // it doesn't need to do anything else.
      }
      document.getElementById('pagewrap').classList.remove('hide');
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    logger.logError({
      message: `Failed to initialise client side ${err}`,
      component: 'index',
    });
  }
})();
